import { RegisterMode } from '../registrationMode.js';

export const registrationSections = [
  { id: 'sus-info', label: 'Info' },
  { id: 'sus-child', label: 'Kind' },
  { id: 'sus-guardians', label: 'Sorgeberechtigte' },
  { id: 'sus-school', label: 'Schule' },
  { id: 'sus-documents', label: 'Dokumente' },
  { id: 'sus-motivation-section', label: 'Motivation' },
  { id: 'sus-interview', label: 'Aufnahmegespräch' },
] as const;
export type RegistrationSectionID = (typeof registrationSections)[number]['id'];

/** An update keeps the interview the school already arranged, so it never asks for one. */
export const sectionsForMode = (mode: RegisterMode, update = false) =>
  registrationSections.filter(
    section => section.id !== 'sus-interview' || (mode === RegisterMode.REGISTRATION_ELEMENTARY_HIGH && !update),
  );

export const registrationSectionKey = (token: string) => `sus-register-section:${token}`;

export function readRegistrationSection(storage: Pick<Storage, 'getItem'>, token: string): RegistrationSectionID {
  try {
    const saved = token ? storage.getItem(registrationSectionKey(token)) : null;
    return registrationSections.find(section => section.id === saved)?.id ?? 'sus-info';
  } catch {
    return 'sus-info';
  }
}

/** Field paths also locate errors when an optional field currently has no rendered control. */
export function sectionForField(path: string): RegistrationSectionID {
  const root = path.split('.')[0];
  if (root === 'sorgeberechtigte') return 'sus-guardians';
  if (root === 'files') return 'sus-documents';
  if (root === 'selectedInterviewSlotID') return 'sus-interview';
  if (root === 'motivation' || root === 'schulwechselMotivation') return 'sus-motivation-section';
  if (
    [
      'klassenstufe',
      'potentialMartinusElementarySchoolID',
      'potentialMartinusElementarySchoolName',
      'currentKlassenstufe',
      'schoolyearsAfterElementary',
      'lastGradeGerman',
      'lastGradeMath',
      'lastGradeSachunterricht',
      'interestInNativeLanguageCourses',
      'interestInWholeDaySchooling',
    ].includes(root ?? '')
  )
    return 'sus-school';
  return 'sus-child';
}

/** A picked field, and everything below it (picking one file clears a `files` error), is no longer in error. */
export const pickClearsError = (pickedPath: string, errorPath: string) => `${pickedPath}.`.startsWith(`${errorPath}.`);
